import React, { useEffect, useState } from 'react'
import GenerateMasterKey from './GenerateMasterKey'
import { useSearchParams } from 'react-router-dom';
import Title from './Title';
import Divider from './Divider';
import RequestIDT from './RequestIDT';
import Steps from './Steps';

const Body = (props:any) => {

    const [searchParams, setSearchParams] = useSearchParams();
    const [requestMpkToken, setRequestMpkToken] = useState("");

    useEffect(() => {
        let tempTokenStr = searchParams.get("request_mpk_token");
        let tempTokenStr2 = searchParams.get("id_token");
        if(tempTokenStr){
            setRequestMpkToken(tempTokenStr) 
        }
        else if(tempTokenStr2) {
            setRequestMpkToken(tempTokenStr2) 
        }
        else {
            setRequestMpkToken("");
        }
      
    }, [searchParams]);

    return (
        <div className="flex flex-col w-full  gap-10" /*overflow-x-auto*/>

            <Title />
            <Divider/>

            <div className='flex flex-col md:flex-row gap-8 md:gap-0 justify-between '>
                <Steps />

                {requestMpkToken === "" ?  <GenerateMasterKey /> :<RequestIDT/>}

            </div>

        </div>
    )
}

export default Body
